import { render, staticRenderFns } from "./novel_extension.vue?vue&type=template&id=668bee44&scoped=true"
import script from "./novel_extension.vue?vue&type=script&lang=js"
export * from "./novel_extension.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668bee44",
  null
  
)

export default component.exports